import { useMemo } from "react";

import { Conversation } from "shared/apiClient";
import { AccountType } from "shared/types";
import { sortByDate } from "@/lib/utils";

import { useMessages } from "@/hooks";

export type UseLatestMessageOptions = {
  senderAccountType?: AccountType;
  messages?: Conversation["messages"];
};

export function useLatestMessage(options?: UseLatestMessageOptions) {
  const { senderAccountType, messages: messagesOverride } = options || {};

  const { messages } = useMessages();

  return useMemo(() => {
    const actualMessages = messagesOverride ? messagesOverride : messages;

    return actualMessages
      ?.filter((message) => {
        if (senderAccountType) {
          return message.sender_account_type === senderAccountType;
        }
        return true;
      })
      .sort(sortByDate)
      .at(-1);
  }, [messages, messagesOverride, senderAccountType]);
}
